import parse, {
  HTMLReactParserOptions,
  attributesToProps,
  domToReact,
} from 'html-react-parser';
import { useRouter } from 'next/router';
import styles from './index.module.scss';

export interface IntroProps {
  id: any;
  body: string;
  children: string;
}

export const Intro = ({ id, body, children, ...rest }: IntroProps) => {
  const { query } = useRouter();
  const params = new URLSearchParams(JSON.parse(JSON.stringify(query)));
  const paramsString = params.toString();

  const options: HTMLReactParserOptions = {
    replace: (domNode: any) => {
      if (
        domNode.name === 'a' &&
        domNode.attribs &&
        !domNode.attribs.href.startsWith('mailto:')
      ) {
        const props = attributesToProps(domNode.attribs);
        return (
          <a
            {...props}
            href={`/${id}/outbound?url=${encodeURIComponent(
              domNode.attribs.href,
            )}&${paramsString}`}
            rel="noopener noreferrer"
            target="_blank"
          >
            {domToReact(domNode.children, options)}
          </a>
        );
      }
    },
  };

  let content = body;
  content = content?.indexOf('<p>') > -1 ? content : `<p>${content}</p>`;

  return (
    <section className={`component ${styles.intro}`} {...rest}>
      {children || parse(content, options)}
    </section>
  );
};

Intro.defaultProps = {
  body: '',
} as Partial<IntroProps>;
